import PropTypes from 'prop-types';

export default PropTypes.shape({
  standing_order_uuid: PropTypes.string.isRequired,
  reference: PropTypes.string,
  amount: PropTypes.number.isRequired,
  fromAccount: PropTypes.string.isRequired,
  toAccountName: PropTypes.string.isRequired,
  toAccountNumber: PropTypes.string.isRequired,
  toAccountSortCode: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  frequency: PropTypes.string,
  stopPaymentOption: PropTypes.string,
  stopPaymentOnNumber: PropTypes.number,
});
